import { render } from "./cube.vue?vue&type=template&id=11d3c122"
import script from "./cube.vue?vue&type=script&lang=js"
export * from "./cube.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__